import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(new)/error.tsx");
